import { Component, OnInit, Input } from '@angular/core';
import { SidenavMenuService } from './sidenav-menu.service';
import { AppService } from 'src/app/app.service';
import { SidenavMenu } from './sidenav-menu.model';
import { Location } from '@angular/common';
import { SidebarService } from 'src/app/sidebar.service';
import { Router } from '@angular/router';
import { LocalStorage } from '@ngx-pwa/local-storage';
@Component({
  selector: 'app-sidenav-menu',
  templateUrl: './sidenav-menu.component.html',
  styleUrls: ['./sidenav-menu.component.scss'],
  providers: [SidenavMenuService]
})
export class SidenavMenuComponent implements OnInit {
  @Input('menuItems') menuItems;
  @Input('menuParentId') menuParentId;
  parentMenu: Array<any>
  DparentMenu: Array<any>
  SparentMenu: Array<any>
  MparentMenu: Array<any>
  detailsarray: Array<SidenavMenu> = [];
  visibleloader: boolean = true;
  constructor(private sidenavMenuService: SidenavMenuService, protected localStorage: LocalStorage, public appService: AppService, private sidebarService: SidebarService, private router: Router,) {

  }


  ngOnInit() {
    if (this.appService.Data.user_details) {

      this.addMenuItemsBasedOnRole();
      this.filterParentMenu();
    }
  }

  private addMenuItemsBasedOnRole() {
    const { role_id, vendor_register, user_details } = this.appService.Data;

    const privilegeIds = user_details.privilages.map(p => p.privilege_id);

    // Always add menu item with id 0 for all users
    this.detailsarray = [this.menuItems.find(item => item.id === 0)];

    if (role_id == 1) {
      this.detailsarray = this.detailsarray.concat(
        this.menuItems.filter(item => item.parentId == this.menuParentId && item.id != 3 && privilegeIds.includes(item.id))
      );
    } else if (role_id == 3 || !vendor_register) {
      this.detailsarray = this.detailsarray.concat(
        this.menuItems.filter(item => privilegeIds.includes(item.id))
      );
    } else if (vendor_register) {
      this.detailsarray = this.detailsarray.concat(
        this.menuItems.filter(item => item.parentId == this.menuParentId && item.id == 3 && privilegeIds.includes(item.id))
      );
    }

  }

  private filterParentMenu() {

    //  Daily Monitoring,Sell More,Manage your business
    this.parentMenu = this.detailsarray.filter(item =>
      item.parentId == this.menuParentId &&
      !['Daily Monitoring', 'Sell More', 'Manage your business'].includes(item.groupTitle)
    );
    if (this.menuParentId == 0) {/// This Section is only for Main Menu
      this.DparentMenu = this.detailsarray.filter(item => item.groupTitle == 'Daily Monitoring' && item.parentId == this.menuParentId);
      this.SparentMenu = this.detailsarray.filter(item => item.groupTitle == 'Sell More' && item.parentId == this.menuParentId);
      this.MparentMenu = this.detailsarray.filter(item => item.groupTitle == 'Manage your business' && item.parentId == this.menuParentId);
    }


  }
  onClick(menu) {


    var menuId = menu.id;
    if (this.checkIfMobileDevice() && !menu.hasSubMenu) {//Mobile Route
      this.router.navigate([menu.routerLink]);
      this.sidebarService.toggleSidebar(false);
    } else if (menu.routerLink) {
      this.router.navigate([menu.routerLink]);
    }
    this.sidenavMenuService.toggleMenuItem(menuId);
    this.sidenavMenuService.closeOtherSubMenus(this.menuItems, menuId);

  }
  checkIfMobileDevice() {
    var ua = navigator.userAgent;

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua))
      return true;

    else if (/Chrome/i.test(ua))
      return false;

    else
      return false;
  }

  signout() {
    this.appService.signOut();
  }

}
